module.exports = __webpack_public_path__ + "Flama-Black.ttf?ecea963f3d107be291bc14b140a6f517";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Black.ttf
// module id = 925
// module chunks = 0